<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },

  created() {
    this.$store.dispatch("medicines/getForEdit", this.itemId).then((res) => {
      this.vm = res
    });

    this.$store.dispatch("lookups/getLookups");

    this.$store.dispatch("lookups/getDepartments");

  },
  computed: {
    medicineTypes() {
      return [
        ...this.$store.getters["lookups/getLookupByType"](
          this.$lookupTypes.MedicineTypes
        )];
    },
    units() {
      return [
        ...this.$store.getters["lookups/getLookupByType"](
          this.$lookupTypes.UnitTypes
        )];
    },
    departments() {
      return this.$store.state.lookups.departments;

    }

  },
  data() {
    return {
      vm: {
        medicineName: null,
        medicineTypeId: null,
        unitId: null,
        dosage: null,
        description: null,
        departmentId: null,

      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("medicines/edit", { id: this.itemId, payload: this.vm })
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    allowedDates(val) {
      const today = new Date();
      // today.setFullYear(today.getFullYear() - 15);
      const date = new Date(val);
      return date < today;
    },
    back() {

      this.$emit("back");
    },
  },
};
</script>